var inScene = null;
var outScene = null;
var currentWidth = $(window).width();

$(function () {
    // $('html, body').height($(window).height());
    // if($(window).width() > $(window).height()) {
    //     $('.section-1-1').height($(window).height() * 6.5);
    // } else {
    //     $('.section-1-1').height($(window).height() * 4.5);
    // }

    timelineScrollInit();
    // }
    let resizedFinished;
    $(window).on('resize', function() {
        if($(window).width() !== currentWidth) {
            clearTimeout(resizedFinished);
            resizedFinished = setTimeout(function(){
                timelineScrollInit();
            }, 250);

            currentWidth = $(window).width();

            $('section.section-1-1 .pinned').height($(window).height());
        }
    });

    $('.video-modal-button').click(function(e){
       e.preventDefault();
       $('#modal-video iframe').attr('src', $(this).attr('data-url'));
       $('#modal-video').modal('show');
    });

    $('#modal-video').on('hidden.bs.modal', function (e) {
        $('#modal-video iframe').attr('src', '');
    })

});

// horizontal scroll tween
function timelineScrollInit() {
    // var windowWidth = $(window).width();
    if(inScene !== null){
        outScene.destroy(true);
        inScene.destroy(true);
    }

    var gap = $('.section-1-1 .container .content').width() - $('.section-1-1 .container').width();

    if(gap > 0 && $(window).width() > 768) {
        // horizontal scroll tween
        var section1_1Horizontal = new TimelineMax().to(".section-1-1 .content", 1,   {x: "-"+ gap +"px"})

        var durationPin = "450%";
        var durationHorizontal = "400%";
        durationPin = $(window).height()*4.5;
        durationHorizontal = $(window).height()*4;
        
        if($(window).width() > $(window).height()) {
            if ($(window).width() > 1024) {
                durationPin = "550%";
                durationPin = $(window).height()*5.5;
            }
        }

        // create scene to pin and link animation
        inScene = new ScrollMagic.Scene({
            triggerElement: ".section-1-1 .pinned",
            triggerHook: 0,
            duration: durationPin
        }) 
        .setPin(".section-1-1 .pinned", {pushfollowers: false})
        .addTo(require('../scrollInit'));

        outScene = new ScrollMagic.Scene({
            offset: 100,
            triggerElement: ".section-1-1 .pinned",
            triggerHook: 0,
            duration: durationHorizontal
        })
        .setTween(section1_1Horizontal)
        .addTo(require('../scrollInit'));

        // create scene to pin and link animation
    }  
    AOS.refresh();
}